import React, { useEffect, useState } from 'react';
import { RoomEventItem } from '../../../Types/RoomEvent';
import { setModalData } from '../../Shared/SharedSlices/ModalSlice';
import { useDispatch, useSelector } from 'react-redux';
import { setRoomEventsData } from '../RoomSlices/RoomEventsSlice';
import { RootState } from '../../../App/store';
import Image from "../../Shared/Primitive/Image"
import { formatDate } from '../../../App/Helpers/Helpers';

const RoomEventListItem: React.FC<{ event: RoomEventItem }> = ({ event }) => {
    const roomEventsData = useSelector((state: RootState) => state.roomEventsSlice)
    const dispatch = useDispatch()

    const onItemClick = () => {
        dispatch(setRoomEventsData({ ...roomEventsData, selectedItem: event }))
        dispatch(setModalData({ open: true, roomEventModal: true }))
    }

    return (
        <div onClick={onItemClick} key={event.id} className="room-events__item">
            <div className='room-events__item-left-panel'>
                <div className="room-events__item-date">
                    <div className='room-events__item-date-day'>
                        {new Date(event.start_date).toLocaleDateString(undefined, { day: 'numeric' })}
                    </div>
                    <div className='room-events__item-date-month'>
                        {new Date(event.start_date).toLocaleDateString(undefined, { month: 'short' })}
                    </div>
                </div>
            </div>
            <div className='room-events__item-middle-panel'>
                <div className="room-events__image-container">
                        {event?.image ? (<Image src={event.image} className="room-events__image-container" />) : (
                            <Image src="/event_default.png" className="room-events__image-container" />
                        )}
                    </div>
            </div>
            <div className='room-events__item-right-panel'>
                <div className='room-events__item-date-range'>
                    {formatDate(event.start_date, 'dd.MM.yyyy HH:mm')}
                    {event.end_date && event.end_date !== event.start_date && (
                        <> - {formatDate(event.end_date, 'dd.MM.yyyy HH:mm')}</>
                    )}
                </div>
                <div className="room-events__item-title"><h4>{event.title}</h4></div>
                <div className="event-modal__tags-content">
                    {event?.keywords?.map((keyword, index) => (
                        <div key={index} className="event-modal__tag">{keyword}</div>
                    ))}
                </div>
                <div className="room-events__item-description">
                    <div dangerouslySetInnerHTML={{ __html: event.description.slice(0, 100) + (event.description.length > 100 ? '...' : '') }} />
                </div>
                <div className='room-events__details'>
                    {event.location_type} {event.formats && `- ${event.formats}`} {event.admission && `- ${event.admission}`}
                </div>
            </div>
        </div>
    )
}

export default RoomEventListItem